import { types } from 'mobx-state-tree';

const PlanTemplateFlag = types
  .model('PlanTemplateFlag', {
    id: types.identifier,
    name: types.string,
  });

export default PlanTemplateFlag;
